var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1419_30384",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1419_30384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14.903C16.4604 14.903 16.8464 14.7443 17.1578 14.4269C17.4693 14.1095 17.625 13.7163 17.625 13.2471V8.27943C17.625 7.81026 17.4693 7.41699 17.1578 7.09961C16.8464 6.78223 16.4604 6.62354 16 6.62354C15.5396 6.62354 15.1536 6.78223 14.8422 7.09961C14.5307 7.41699 14.375 7.81026 14.375 8.27943V13.2471C14.375 13.7163 14.5307 14.1095 14.8422 14.4269C15.1536 14.7443 15.5396 14.903 16 14.903ZM16 21.5265C16.4604 21.5265 16.8464 21.3678 17.1578 21.0505C17.4693 20.7331 17.625 20.3398 17.625 19.8706C17.625 19.4015 17.4693 19.0082 17.1578 18.6908C16.8464 18.3734 16.4604 18.2147 16 18.2147C15.5396 18.2147 15.1536 18.3734 14.8422 18.6908C14.5307 19.0082 14.375 19.4015 14.375 19.8706C14.375 20.3398 14.5307 20.7331 14.8422 21.0505C15.1536 21.3678 15.5396 21.5265 16 21.5265ZM16 28.7296C19.3042 25.6386 21.7552 22.8305 23.3531 20.3053C24.951 17.7801 25.75 15.5377 25.75 13.5783C25.75 10.5701 24.8089 8.10694 22.9266 6.18887C21.0443 4.27081 18.7354 3.31177 16 3.31177C13.2646 3.31177 10.9557 4.27081 9.07344 6.18887C7.19115 8.10694 6.25 10.5701 6.25 13.5783C6.25 15.5377 7.04896 17.7801 8.64688 20.3053C10.2448 22.8305 12.6958 25.6386 16 28.7296ZM16 32C15.6208 32 15.2417 31.931 14.8625 31.793C14.4833 31.655 14.1448 31.448 13.8469 31.1721C12.0865 29.5162 10.5292 27.9017 9.175 26.3286C7.82083 24.7555 6.6901 23.2307 5.78281 21.7542C4.87552 20.2777 4.1849 18.8564 3.71094 17.4903C3.23698 16.1242 3 14.8202 3 13.5783C3 9.43855 4.30677 6.14058 6.92031 3.68435C9.53385 1.22812 12.5604 0 16 0C19.4396 0 22.4661 1.22812 25.0797 3.68435C27.6932 6.14058 29 9.43855 29 13.5783C29 14.8202 28.763 16.1242 28.2891 17.4903C27.8151 18.8564 27.1245 20.2777 26.2172 21.7542C25.3099 23.2307 24.1792 24.7555 22.825 26.3286C21.4708 27.9017 19.9135 29.5162 18.1531 31.1721C17.8552 31.448 17.5167 31.655 17.1375 31.793C16.7583 31.931 16.3792 32 16 32Z",
    fill: "#AE2573"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.f13b7c5edb8a9f04cda561ba0f58ddd4.svg";
export { ForwardRef as ReactComponent };